import { Component } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { MenuController } from '@ionic/angular';

import { ProfileService } from '../services/profile/profile.service';

import { SetLanguagePage } from './settings/set-language/set-language.page';
import { SetCachePage } from './settings/set-cache/set-cache.page';
import { SetProfilePage } from './settings/set-profile/set-profile.page';
import { ShowTermsPage } from './settings/show-terms/show-terms.page';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  public showSearch = false;
  public searchWord = "";

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private profileService: ProfileService,
    private modalController: ModalController,
    private menuController: MenuController
  ) {
    console.log("main app constructed");
  }

  ngOnInit() {
    //starting up splash screen
    console.log("main nginit")
    this.platform.ready().then(() => {
      this.statusBar.overlaysWebView(false);
      this.statusBar.styleLightContent();
      this.statusBar.backgroundColorByHexString('#041333');
      //commented out because we need to display it for the full time at least.
      //this.splashScreen.hide();
      if (this.profileService.isFirstUsage)
        this.setUpConfig();
    });
  }

  async setUpConfig() {
    const modal = await this.modalController.create({
      component: SetLanguagePage
    });
    await modal.present();
    await modal.onDidDismiss();


    const modal3 = await this.modalController.create({
      component: SetProfilePage
    });
    await modal3.present();
    await modal3.onDidDismiss();

    const modalt = await this.modalController.create({
      component: ShowTermsPage
    });
    await modalt.present();
    await modalt.onDidDismiss();

    const modal2 = await this.modalController.create({
      component: SetCachePage
    });
    await modal2.present();
    await modal2.onDidDismiss();

  }

  public closeMenu() {
    this.menuController.close();
  }


  public change(e) {
    this.searchWord = e.detail.value;
  }
}
